import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "example" }
const _hoisted_2 = { class: "tab-scroll" }
const _hoisted_3 = { class: "radio-select" }
const _hoisted_4 = { class: "tab-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Sandpack_cmp = _resolveComponent("Sandpack-cmp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.radio,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radio) = $event)),
          class: "ml-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: "0",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode("React")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              label: "1",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Vue")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_tabs, {
        class: "customer-tab",
        type: "card",
        onTabClick: _ctx.onClick,
        "model-value": _ctx.tabName,
        "tab-position": _ctx.tabPosition
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needRendertabs, (tab, index) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              name: tab.refName,
              key: index,
              label: tab.name
            }, null, 8, ["name", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onTabClick", "model-value", "tab-position"])
    ]),
    _createElementVNode("div", {
      class: "example-doc scroll-content",
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needRendertabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "scroll-item",
          ref_for: true,
          ref: _ctx.needRendertabs[index].refName,
          key: index
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(tab.name), 1),
          _createVNode(_component_Sandpack_cmp, {
            "code-map": tab,
            frame: _ctx.frame
          }, null, 8, ["code-map", "frame"])
        ]))
      }), 128))
    ], 32)
  ]))
}